var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"color":"success","label":_vm.label},on:{"change":function($event){return _vm.$emit('update:subscribed', _vm.subscribedLocal);}},model:{value:(_vm.subscribedLocal),callback:function ($$v) {_vm.subscribedLocal=$$v},expression:"subscribedLocal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }